import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import {BiDownArrow} from "react-icons/bi";
import {AnimatePresence, motion} from "framer-motion";
import TextareaAutosize from 'react-textarea-autosize';
import {toast} from "react-toastify";
import {wait} from "@testing-library/user-event/dist/utils";
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import AnswerDropDown from "../component/AnswerDropDown";
import {MapOptions} from "./IdentifyTheIdea";


function MapQuestion({question, answer, setAnswer, showAnswer, transcript}) {

    return question?.text?.split(" ").map((word, wordIndex) => {
        return <span key={wordIndex} className={"text-bawa  "}>{word} </span>
    })
}


export default function TitleThePassage({className, ...props}) {
    const {id} = useParams()
    const [response, setResponse] = useState(null)
    const {question, questionActions, isLoading} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
    }, true)


    function submitAnswer() {
        if (form?.answer.length === 0) {
            actions.setError({
                non_field_errors: ["Please select an option"]
            })
            return
        }
        actions.post(URLS.genericQuestionView).then(response => {
            setResponse(response?.data)
            setShowModal(true)
        })


    }

    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id]);


    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader {...question}
                            timeLimit={question?.timeLimit && question?.timeLimit + 10000}

            />
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>
                <div className={"flex flex-1 px-8 flex-col gap-4"}>

                    <div className={"text-lg font-semibold gap-2 flex items-center align-middle flex-1 flex-wrap"}>
                        <MapQuestion
                            question={question}
                            showAnswer={!!response}
                            transcript={question?.transcript}
                            setAnswer={(ans) => setFormData({answer: ans})}
                            answer={form?.answer}
                        />
                    </div>
                    <div className={"text-lg font-semibold   gap-4 flex flex-1 flex-col"}>
                        <MapOptions
                            question={question}
                            showAnswer={!!response}
                            transcript={question?.transcript}
                            setAnswer={(ans) => {
                                setFormData({answer: ans})
                            }}
                            answer={form?.answer}
                        />
                    </div>
                    <FormNoneFieldErrors className={"mt-3"}
                                         errors={error?.answer || error?.non_field_errors || error?.time}/>


                </div>


            </div>
            <QuestionFooter
                loading={loading}
                disabled={!!response}
                onClickSubmit={submitAnswer}
                className={"mx-4 my-2"}/>

            <AnswerDropDown
                headerTitle={"Answer"}
                justifications={
                    question?.explanation?.split("\n").map((line, index) => {
                        return <p key={index}>{line}</p>
                    })
                }
            />
        </div>

    )
}